import { jsx } from 'react/jsx-runtime';
import { ButtonContext } from '@zapier/design-system';
import clsx from 'clsx';
import { useMemo } from 'react';

const modalDialogFooter = "_modal-dialog-footer_ynl6j_1";
const styles = {
	modalDialogFooter: modalDialogFooter
};

const ModalDialogFooter = ({ children, className, style }) => {
  const contextValue = useMemo(() => ({ size: "medium" }), []);
  return jsx("footer", { className: clsx(styles.modalDialogFooter, className), "data-zds": true, style, children: jsx(ButtonContext.Provider, { value: contextValue, children }) });
};

export { ModalDialogFooter };
//# sourceMappingURL=Footer.es.js.map
